import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetGroupDetailsParams {
  id: string; // the group's id
}

export interface IGetGroupDetailsResult extends IResult {
  id: string; // group id
  name: string; // group name. "All Users" group is already localized by the backend.
  createdAt: string;
  updatedAt: string;
  domainType: string;
  domainName?: string;
  isAllUsersGroup: boolean;
  minimumSiteRole?: string; // Returned for all active directory groups (domainType === 'activeDirectory')
}

export class GetGroupDetailsRequest extends Request<IGetGroupDetailsParams, IGetGroupDetailsResult> {
  constructor(params: IGetGroupDetailsParams) {
    super('getGroup', params);
  }
}
